/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const TimestampGreaterThanOrEqual: core.serialization.ObjectSchema<
    serializers.TimestampGreaterThanOrEqual.Raw,
    Truvity.TimestampGreaterThanOrEqual
> = core.serialization.object({
    value: core.serialization.date(),
});

export declare namespace TimestampGreaterThanOrEqual {
    export interface Raw {
        value: string;
    }
}
